export type TAnswerOption = { label: string; value: string };

export function buildAnswerOptions(
  options: { id: string; label?: Partial<Record<string, string>> }[],
  languages: string[],
): TAnswerOption[] {
  return options.map((option) => ({
    value: option.id,
    label: languages.map((language) => option.label?.[language] ?? '').join(' / '),
  }));
}
